import CryptoJS from "crypto-js"

export const hashToMd5 = (input) => {
 return CryptoJS.MD5(input);
}